<template>
  <div class="warn-ms">
    <el-card class="card">
      <div slot="header" class="clearfix">
        <span>警告详情</span>
      </div>
      <div class="warn-list">
        <div class="warn-cont" v-for="(i, index) in warnList" :key="index">
          <div class="info-top">
            <div class="info-name">
              <i class="iconfont iconicon_warning"
              ></i>
              <span>{{ i.concernsId }}</span>
            </div>
            <div class="info-time">
              <span>{{ i.createTime | dateFormat("yyyy-M-d hh:mm") }}</span>
            </div>
          </div>
          <div class="info-bottom">
            <p>{{ i.messageText }}</p>
            <i :class="i.isRead === 1? '' : 'reds'"></i>
          </div>
        </div>
      </div>
      <el-pagination layout="prev, pager, next" :hide-on-single-page="false" :total="count" :page-size="linit" @current-change="handleCurrentChange">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import ApiService from "@/services/API-services";
export default {
  name: "warnMs",
  data() {
    return {
      warnList: [],
      page: 1,
      linit: 20,
      count: 0,
    };
  },
  created() {
    this.getAlertList();
    this.createWS();
  },
  methods: {
    // 获得警告列表
    getAlertList() {
      ApiService.user
        .getAlertList({
          userId: JSON.parse(localStorage.user).userId,
          page: this.page,
          linit: this.linit,
          IsRead: 1,
        })
        .then((res) => {
          if (res.code === 0) {
            this.warnList = res.data;
            this.count = res.count;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val
      this.getAlertList()
    },
    createWS() {
      var _this = this;
      this.socket = new window.WebSocket(window.R_config.warnSocket);
      this.socket.onclose = function () {
        console.log("警报 close");
        setTimeout(function () {
          _this.reconect();
        }, 2000);
      };
      this.socket.onopen = function () {
        console.log("警报 successed");
        _this.socket.send(`UserId=${JSON.parse(localStorage.user).userId}`);
      };
      this.socket.onmessage = function (msg) {
        // console.log(msg)
        _this.getAlertList();
      };
    },
  },
};
</script>

<style lang="scss">
@import "../../common/css/color.scss";
.warn-ms {
  width: 1200px;
  .el-pagination {
    color: #fff;
    .el-pager li.btn-quicknext, .el-pager li.btn-quickprev {
      color: #fff;
    }
  }
  .el-card__body {
    padding: 0;
    .warn-list {
      display: flex;
      height: 500px;
      color: $font_color;
      padding: 24px;
      display: flex;
      flex-direction: column;
      overflow: auto;
      .warn-cont {
        width: 100%;
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
        margin: 5px 0;
        padding: 5px 0;
        .info-top {
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 5px 10px;
          i {
            color: red;
          }
          .info-time {
            font-size: 12px;
            color: rgba(255, 255, 255, 0.65);
          }
        }
        .info-bottom {
          color: rgba(255, 255, 255, 0.85);
          font-size: 14px;
          padding: 5px 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            width: 90%;
            text-align: left;
          }
          .reds {
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background: red;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mind/warnMs.vue